import api from "../api";

export default {
    index(params) {
        return api.get(`/central/orders`, {
            params: params
        })
    },
    show(id) {
        return api.get(`/central/orders/${id}`)
    }
}
